import makeValidationSchema from './UserForShipperRequestMakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import UserForShipperRequestKeys from 'src/constants/locale/key/UserForShipperRequest'
import { Grid } from '@material-ui/core'
import {
  components,
} from 'cng-web-lib'

const {
  form: {
    field: {
      CngTextField,
      CngSelectField,
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  userProfileId: 0,
  partyId: 0,
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, showNotification, shouldHideMap }) {
  const { translate } = useTranslation(Namespace.USER_FOR_SHIPPER_REQUEST)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let userProfileId = translate(
      Namespace.USER_FOR_SHIPPER_REQUEST,
      UserForShipperRequestKeys.USER_PROFILE_ID
    )
    let partyId = translate(
      Namespace.USER_FOR_SHIPPER_REQUEST,
      UserForShipperRequestKeys.PARTY_ID
    )

    return {
      userProfileId,
      partyId
    }
  }

	return (
    <Grid container spacing={3}>
      <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.userProfileId}>
        <CngSelectField
          name="userProfileId"
          type="number"
          label={translatedTextsObject.userProfileId}
          disabled={disabled}
          fetch={{url: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/user/get`, textAccessor: "loginId"}}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.partyId}>
        <CngSelectField
          name="partyId"
          type="number"
          label={translatedTextsObject.partyId}
          disabled={disabled}
          fetch={{url: `${process.env.REACT_APP_TPR_ORIGIN_URL}/tpr/party/get`, textAccessor: "name"}}
        />
      </CngGridItem>
    </Grid>
	)
}

function toClientDataFormat(serverData) {
  let localData = serverData;
  return localData;
}

function toServerDataFormat(localData) {
  return localData;
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties
